<template>
       
    <div class="container">
        <div class="py-3 text-center">            
            <h2>Estado de Compra</h2>  
            <hr>          
        </div>                

        <div class="container" v-if="validationMessage" style="margin-top: -50px;">
            <div class="row justify-content-center">
                <div class="col-md-12">
                    <div :class="validationMessage.data.data.status == 'APPROVED' ? 'message-box _success' : 'message-box _success _failed'">
                        <i :class="validationMessage.data.data.status == 'APPROVED' ? 'fa fa-check-circle' : 'fa fa-times-circle'" aria-hidden="true"></i>
                        <br><br>
                        <h5>#{{ validationMessage.data.data.id }}</h5>
                        <h2> 
                            {{  
                                validationMessage.data.data.status == 'APPROVED' ? 'La transacción ha sido APROBADA' : 
                                validationMessage.data.data.status == 'DECLINED' ? validationMessage.data.data.status_message : 
                                validationMessage.data.data.status == 'VOIDED' ? 'La transacción ha sido ANULADA' : 
                                validationMessage.data.data.status_message                           
                            }} 
                        </h2>
                        <table class="table table-borderless">
                            <thead>
                                <tr>
                                    <th scope="col">Item</th>
                                    <th scope="col">Resultado</th>                        
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Fecha</td>
                                    <td>{{ formatDate(validationMessage.data.data.created_at) }}</td>
                                </tr>
                                <tr>
                                    <td>Estado</td>
                                    <td>
                                        {{ 
                                            validationMessage.data.data.status == 'APPROVED' ? 'APROBADA' : 
                                            validationMessage.data.data.status == 'DECLINED' ? 'RECHAZADA' : 
                                            validationMessage.data.data.status == 'VOIDED' ? 'ANULADA' : 
                                            'ERROR VALIDACIÓN' 
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Referencia</td>
                                    <td>{{ validationMessage.data.data.reference }}</td>
                                </tr>
                                <tr>
                                    <td>Valor</td>
                                    <td>$ {{ formatNumber(validationMessage.data.data.amount_in_cents /100)  }}</td>
                                </tr>
                                <tr>
                                    <td>Moneda</td>
                                    <td> {{ validationMessage.data.data.currency  }}</td>
                                </tr>
                                <tr>
                                    <td>Método de Pago</td>
                                    <td> {{ validationMessage.data.data.payment_method.type  }}</td>
                                </tr>
                                <tr v-if="validationMessage.data.data.payment_method.type == 'CARD'">
                                    <td>Tarjeta</td>
                                    <td> {{ validationMessage.data.data.payment_method.extra.name  }}</td>
                                </tr>
                            </tbody>
                        </table>     
                    </div> 
                </div> 
            </div> 
        
        </div> 
        <div v-else>
            <div class="payment-loader">
                <div class="pad">
                    <div class="chip"></div>
                    <div class="line line1"></div>
                    <div class="line line2"></div>
                </div>
                <div class="loader-text">
                    Cargando datos del pago...
                </div>
            </div>
        </div>
       
    </div>       
  
</template>
<script>

import {headers} from './../../api/headers'
import {configApi} from './../../api/configApi'

export default {
    name: 'dashboard',
    data: () => ({        
        validationMessage: [],   
    }),
    created() {
         // Usar URLSearchParams para obtener los parámetros de la URL
        // const params = new URLSearchParams(window.location.search);

        // // Obtener el valor del parámetro 'id' y 'env'
        // this.transactionId = params.get('id');
        // this.environment = params.get('env');

        // // Ahora puedes hacer lo que necesites con estos valores, como enviarlos a tu backend para validación
        // console.log('ID de transacción:', this.transactionId);
        // console.log('Ambiente:', this.environment);
        this.validatePayment();
    }, 
    methods: {
        async validatePayment() {

            // Capturamos el transaction_id de la URL
            const params = new URLSearchParams(window.location.search);
            const transactionId = params.get('id');
            
            if (transactionId) {
                // Enviar el ID de la transacción al backend para verificar el estado del pago
                return this.axios.get(configApi+'payment/wompi/validate-data/'+transactionId, {headers})
                .then(response => {
                    this.validationMessage = response;
                })
                .catch(error => {
                    this.validationMessage = error.response.data.message || 'Error al validar el pago';
                });
            } else {
                this.validationMessage = 'ID de transacción no encontrado';
            }
            
        },        
        navegacion(menu, id_usuplataforma) {
            this.$router.push('/'+menu)
            localStorage.setItem('id_usuario_plataforma', id_usuplataforma)
        },
        formatDate(isoDate) {
            const date = new Date(isoDate);
                    const months = [
                'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
                'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
            ];

            const day = String(date.getDate()).padStart(2, '0');
            const month = months[date.getMonth()]; // Obtener el mes en texto
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            
            return `${day} de ${month} de ${year} ${hours}:${minutes}:${seconds}`;
        },
        formatNumber(number) {
            return number.toLocaleString('es-ES'); // Formato para separar por miles
        }
    }
}
</script>
<style>
._failed{ border-bottom: solid 4px red !important; }
._failed i{  color:red !important;  }

._success {
    box-shadow: 0 15px 25px #00000019;
    padding: 45px;
    width: 100%;
    text-align: center;
    margin: 40px auto;
    border-bottom: solid 4px #28a745;
}

._success i {
    font-size: 55px;
    color: #28a745;
}

._success h2 {
    margin-bottom: 12px;
    font-size: 40px;
    font-weight: 500;
    line-height: 1.2;
    margin-top: 10px;
}

._success p {
    margin-bottom: 0px;
    font-size: 18px;
    color: #495057;
    font-weight: 500;
}

.payment-loader {
  width : 150px;
  position: absolute;
  top: 50%;
  left : 50%;
  -webkit-transform: translateY(-50%) translateX(-50%);
  -moz-transform: translateY(-50%) translateX(-50%);
  -o-transform: translateY(-50%) translateX(-50%);
  transform: translateY(-50%) translateX(-50%);
}

.payment-loader .binding {
  content : '';
  width : 60px;
  height : 4px;
  border : 2px solid #00c4bd;
  margin : 0 auto;
}

.payment-loader .pad {
  width : 60px;
  height : 38px;
  border-radius : 8px;
  border : 2px solid #00c4bd;
  padding : 6px;
  margin : 0 auto;
}

.payment-loader .chip {
  width : 12px;
  height: 8px;
  background: #00c4bd;
  border-radius: 3px;
  margin-top: 4px;
  margin-left: 3px;
}

.payment-loader .line {
  width : 52px;
  margin-top : 6px;
  margin-left : 3px;
  height : 4px;
  background: #00c4bd;
  border-radius: 100px;
  opacity : 0;
  -webkit-animation : writeline 3s infinite ease-in;
  -moz-animation : writeline 3s infinite ease-in;
  -o-animation : writeline 3s infinite ease-in;
  animation : writeline 3s infinite ease-in;
}

.payment-loader .line2 {
  width : 32px;
  margin-top : 6px;
  margin-left : 3px;
  height : 4px;
  background: #00c4bd;
  border-radius: 100px;
  opacity : 0;
  -webkit-animation : writeline2 3s infinite ease-in;
  -moz-animation : writeline2 3s infinite ease-in;
  -o-animation : writeline2 3s infinite ease-in;
  animation : writeline2 3s infinite ease-in;
}

.payment-loader .line:first-child {
  margin-top : 0;
}

.payment-loader .line.line1 {
  -webkit-animation-delay: 0s;
  -moz-animation-delay: 0s;
  -o-animation-delay: 0s;
  animation-delay: 0s;
}

.payment-loader .line.line2 {
  -webkit-animation-delay: 0.5s;
  -moz-animation-delay: 0.5s;
  -o-animation-delay: 0.5s;
  animation-delay: 0.5s;
}

.payment-loader .loader-text {
  text-align : center;
  margin-top : 20px;
  font-size : 16px;
  line-height: 16px;
  color : #5f6571;
  font-weight: bold;
}


@keyframes writeline {
  0% { width : 0px; opacity: 0; }
  33% { width : 52px; opacity : 1; }
  70% { opacity : 1; }
  100% {opacity : 0; }
}

@keyframes writeline2 {
  0% { width : 0px; opacity: 0; }
  33% { width : 32px; opacity : 1; }
  70% { opacity : 1; }
  100% {opacity : 0; }
}
</style>